import React from 'react';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './PdfButton.module.css';
import { CommonButton } from '_components';


export class PdfButton extends React.Component {
    render() {
        let cls;
        cls = this.props.color === 'blue' ? styles.button_blue : styles.button;

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'PDF'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faFilePdf} transform="shrink-6" color="white" />
            </CommonButton>
        );
    }
}
